module.exports = __webpack_public_path__ + "static/freya-4724389507caf453e541e3a0d500f766.png";